import _objectSpread from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import platform from './node/index.js';
import * as utils from './common/utils.js';
export default _objectSpread(_objectSpread({}, utils), platform);